import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter, Output, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { SpinnerLoaderService } from 'src/app/core/services/spinner-loader/spinner-loader.service';

@Component({
  selector: 'app-action-button',
  templateUrl: './action-button.component.html',
  styleUrl: './action-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionButtonComponent implements OnInit, OnDestroy {
  @Input() buttonId?: string;
  @Input() buttonClass: string = 'green';
  @Input() label: string = 'حفظ';
  @Input() disabled: boolean = false;

  @Output() submitAction = new EventEmitter<{ buttonId: string }>();
  buttonIdValue = '';
  showSpinner = false;
  private subscription!: Subscription;

  constructor(private spinnerService: SpinnerLoaderService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.buttonIdValue = this.buttonId || `btn-${crypto.randomUUID()}`;
    this.subscription = this.spinnerService.getLoading$(this.buttonIdValue).subscribe(isLoading => {
      this.showSpinner = isLoading;
      this.cdr.markForCheck();
    });
  }

  submit(): void {
    this.submitAction.emit({ buttonId: this.buttonIdValue });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
